import React from "react";

export const IconBoardroom = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 28 28"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m23.625 4.375h-19.25c-0.9665 0-1.75 0.7835-1.75 1.75v11.375c0 0.9665 0.7835 1.75 1.75 1.75h19.25c0.9665 0 1.75-0.7835 1.75-1.75v-11.375c0-0.9665-0.7835-1.75-1.75-1.75z"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m14 22.75v-3.5m0-14.875v-1.75m7.875 22.75-2.0417-5.5417m-13.708 5.5417 1.4583-5.5417"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconBoardroom;
